var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("footer", [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "foot-logo" }),
        _vm._v(" "),
        _c("div", { staticClass: "foot-about" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.showTc($event)
                }
              }
            },
            [_vm._v("Privacy Policy")]
          )
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "https://oneit.rs/", target: "_blank" } }, [
          _vm._v("OneIT")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "side-menu", class: { open: _vm.menuOpen } }, [
      _c("a", {
        staticClass: "close",
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.$emit("update:menuOpen", false)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "mob-only" },
        _vm._l(_vm.menuItems, function(menuItem, mi) {
          return !menuItem.loggedIn || _vm.loggedIn
            ? _c(
                "li",
                {
                  staticClass: "menu-item",
                  class: {
                    open: _vm.currentOpen == mi,
                    active: menuItem.active
                  }
                },
                [
                  _c(
                    "a",
                    {
                      class: { active: menuItem.active },
                      attrs: { href: _vm.resolvedLink(menuItem.link) },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.clickItem(menuItem, mi)
                        }
                      }
                    },
                    [_vm._v("\n    " + _vm._s(menuItem.title) + "\n  ")]
                  ),
                  _vm._v(" "),
                  menuItem.sub && menuItem.sub.length
                    ? _c(
                        "ul",
                        _vm._l(menuItem.sub, function(menuItem2, m2i) {
                          return _c("li", [
                            _c(
                              "a",
                              {
                                class: { active: menuItem2.active },
                                attrs: {
                                  href: _vm.resolvedLink(menuItem2.link)
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.clickItem(menuItem2)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(menuItem2.title) +
                                    "\n      "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            menuItem2.sub && menuItem2.sub.length
                              ? _c(
                                  "ul",
                                  _vm._l(menuItem2.sub, function(
                                    menuItem3,
                                    m3i
                                  ) {
                                    return _c("li", [
                                      _c(
                                        "a",
                                        {
                                          class: { active: menuItem3.active },
                                          attrs: {
                                            href: _vm.resolvedLink(
                                              menuItem3.link
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.clickItem(menuItem3)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(menuItem3.title) +
                                              "\n          "
                                          )
                                        ]
                                      )
                                    ])
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.menuItems2, function(menuItem, mi) {
          return !menuItem.loggedIn || _vm.loggedIn
            ? _c(
                "li",
                {
                  staticClass: "menu-item",
                  class: {
                    open: _vm.currentOpen == mi,
                    active: menuItem.active
                  }
                },
                [
                  _c(
                    "a",
                    {
                      class: { active: menuItem.active },
                      attrs: { href: _vm.resolvedLink(menuItem.link) },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.clickItem(menuItem, mi)
                        }
                      }
                    },
                    [_vm._v("\n    " + _vm._s(menuItem.title) + "\n  ")]
                  ),
                  _vm._v(" "),
                  menuItem.sub && menuItem.sub.length
                    ? _c(
                        "ul",
                        _vm._l(menuItem.sub, function(menuItem2, m2i) {
                          return _c("li", [
                            _c(
                              "a",
                              {
                                class: { active: menuItem2.active },
                                attrs: {
                                  href: _vm.resolvedLink(menuItem2.link)
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.clickItem(menuItem2)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(menuItem2.title) +
                                    "\n      "
                                )
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", [_vm._v("© ")]),
      _vm._v("2021 Kathryn Ross-Nash All Rights Reserved.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }